import React from "react";

export default function WishlistIcon() {
    return (
        <svg
            width="29"
            height="24"
            viewBox="0 0 29 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ height: "auto", width: "auto" }}
        >
            <path
                d="M15 12.9502H8C7.59 12.9502 7.25 12.6102 7.25 12.2002C7.25 11.7902 7.59 11.4502 8 11.4502H15C15.41 11.4502 15.75 11.7902 15.75 12.2002C15.75 12.6102 15.41 12.9502 15 12.9502Z"
                fill="#1A1A1A"
                style={{ fill: "#1A1A1A" }}
            />
            <path
                d="M12.38 16.9502H8C7.59 16.9502 7.25 16.6102 7.25 16.2002C7.25 15.7902 7.59 15.4502 8 15.4502H12.38C12.79 15.4502 13.13 15.7902 13.13 16.2002C13.13 16.6102 12.79 16.9502 12.38 16.9502Z"
                fill="#1A1A1A"
                style={{ fill: "#1A1A1A" }}
            />
            <path
                d="M14 6.75H10C9.04 6.75 7.25 6.75 7.25 4C7.25 1.25 9.04 1.25 10 1.25H14C14.96 1.25 16.75 1.25 16.75 4C16.75 4.96 16.75 6.75 14 6.75ZM10 2.75C9.01 2.75 8.75 2.75 8.75 4C8.75 5.25 9.01 5.25 10 5.25H14C15.25 5.25 15.25 4.99 15.25 4C15.25 2.75 14.99 2.75 14 2.75H10Z"
                fill="#1A1A1A"
                style={{ fill: "#1A1A1A" }}
            />
            <path
                d="M15 22.7499H9C3.38 22.7499 2.25 20.1699 2.25 15.9999V9.99993C2.25 5.43993 3.9 3.48993 7.96 3.27993C8.36 3.25993 8.73 3.56993 8.75 3.98993C8.77 4.40993 8.45 4.74993 8.04 4.76993C5.2 4.92993 3.75 5.77993 3.75 9.99993V15.9999C3.75 19.6999 4.48 21.2499 9 21.2499H15C19.52 21.2499 20.25 19.6999 20.25 15.9999V9.99993C20.25 5.77993 18.8 4.92993 15.96 4.76993C15.55 4.74993 15.23 4.38993 15.25 3.97993C15.27 3.56993 15.63 3.24993 16.04 3.26993C20.1 3.48993 21.75 5.43993 21.75 9.98993V15.9899C21.75 20.1699 20.62 22.7499 15 22.7499Z"
                fill="#1A1A1A"
                style={{ fill: "#1A1A1A" }}
            />
            <path
                opacity="0.4"
                d="M27.6437 7.10534C26.1887 5.65036 24.7638 5.61286 23.2713 7.10534L22.3638 8.01282C22.2888 8.08782 22.2588 8.20782 22.2888 8.31282C22.8588 10.3003 24.4488 11.8903 26.4362 12.4602C26.4662 12.4677 26.4962 12.4752 26.5262 12.4752C26.6087 12.4752 26.6837 12.4452 26.7437 12.3852L27.6437 11.4778C28.3862 10.7428 28.7462 10.0303 28.7462 9.3103C28.7537 8.56781 28.3937 7.84783 27.6437 7.10534Z"
                fill="#292D32"
                style={{ fill: "#1A1A1A" }}
            />
            <path
                d="M25.0869 13.1426C24.8694 13.0376 24.6594 12.9326 24.4569 12.8126C24.2919 12.7152 24.1344 12.6102 23.9769 12.4977C23.8494 12.4152 23.6994 12.2952 23.5569 12.1752C23.5419 12.1677 23.4894 12.1227 23.4294 12.0627C23.1819 11.8527 22.9044 11.5827 22.6569 11.2827C22.6344 11.2677 22.5969 11.2152 22.5444 11.1477C22.4695 11.0577 22.342 10.9077 22.2295 10.7352C22.1395 10.6227 22.0345 10.4577 21.937 10.2927C21.817 10.0902 21.712 9.8877 21.607 9.6777C21.502 9.45271 21.4195 9.23521 21.3445 9.03271L16.6346 13.7426C16.5371 13.8401 16.4471 14.0276 16.4246 14.1551L16.0196 17.0276C15.9446 17.5376 16.0871 18.0176 16.4021 18.3401C16.6721 18.6025 17.0471 18.745 17.4521 18.745C17.5421 18.745 17.6321 18.7375 17.7221 18.7225L20.602 18.3176C20.737 18.2951 20.9245 18.2051 21.0145 18.1076L25.7244 13.3976C25.5144 13.3226 25.3119 13.2401 25.0869 13.1426Z"
                fill="#1A1A1A"
                style={{ fill: "#1A1A1A" }}
            />
        </svg>
    );
}
